import { render, staticRenderFns } from "./Group-Trash.vue?vue&type=template&id=1892b88b&"
import script from "./Group-Trash.vue?vue&type=script&lang=js&"
export * from "./Group-Trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports